<template>
<div class="Banner mb-5 pb-2">
  <b-navbar toggleable="lg" fixed="top" style="background-color: #d5d5d5">
    
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    
    <b-navbar-brand :to="{name: 'main'}">
      <img src="../assets/Logo-gmx1.png" height="30" class="d-inline-block align-middle">
      <img src="../assets/Logo-3.png" height="30" style="padding: 0px 8px">
    </b-navbar-brand>
    
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto" style="font-size: 19px">	
        <b-nav-item class="px-2" :active="activeClass('')">
          <b-link :to="{name: 'main'}">Home</b-link>
        </b-nav-item>
	      <b-nav-item class="px-2" :active="activeClass('products')">
          <b-link :to="{name: 'Products'}">Products</b-link>
        </b-nav-item>
        <b-nav-item class="px-2" :active="activeClass('about')">
          <b-link :to="{name: 'about'}">About Us</b-link>
        </b-nav-item>
        <b-nav-item class="px-2" href="https://graphmetrix.net/"><b-link href="https://graphmetrix.net" target="_blank" style="color: #2e145e">App <font-awesome-icon :icon="iconSignInAlt" /></b-link>
	      </b-nav-item>
        </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  </div>
</template>

<script>
import * as log from 'loglevel'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'Banner',
  props: {
    activeTab: String
  },
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      iconSignInAlt: faSignInAlt
    }
  },
  methods: {
    activeClass: function (tab) {
      if (this.activeTab === tab) {
        return 'active'
        //log.debug("route ",this.$route.fullPath)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
    color: #00000090;
}
a:hover {
    color: #007bff80;
    background-color: #cacaca;
    text-decoration: none;
}
li {
    border-right: solid 1px #00000020;
}
button.navbar-toggler {
    padding: 4px 0px;
}
.nav-link.active {
    background-color: #f8f9fa;
}
</style>